// eslint-disable-next-line no-control-regex
const CONTROL_CHAR_REGEX = /[\x00-\x1F\x7F]/;
const ZERO_WIDTH_REGEX = /[\u200B-\u200D\uFEFF\u2060]/;
const CONSECUTIVE_CHAR_REGEX = /(.)\1{3,}/;

export const PASSWORD_ERRORS = {
  MIN_LENGTH: 'Password must be at least 12 characters long.',
  INVALID_CHARS: 'Password contains invalid characters.',
  CONSECUTIVE_CHARS: 'Password cannot contain more than 3 consecutive identical characters.',
  SAME_AS_PREVIOUS: 'Your new password cannot be the same as your previous one.',
};

export const validatePassword = (password) => {
  const trimmed = password.trim();

  if (trimmed.length < 12) {
    return { valid: false, error: PASSWORD_ERRORS.MIN_LENGTH };
  }

  if (CONTROL_CHAR_REGEX.test(trimmed) || ZERO_WIDTH_REGEX.test(trimmed)) {
    return { valid: false, error: PASSWORD_ERRORS.INVALID_CHARS };
  }

  if (CONSECUTIVE_CHAR_REGEX.test(trimmed)) {
    return { valid: false, error: PASSWORD_ERRORS.CONSECUTIVE_CHARS };
  }

  return { valid: true, error: null };
};

export const isValidPassword = (password) => {
  return validatePassword(password).valid;
};

export const getPasswordRequirementStatus = (password) => {
  const trimmed = password.trim();
  return {
    minLength: trimmed.length >= 12,
    noConsecutive: !CONSECUTIVE_CHAR_REGEX.test(trimmed),
    noInvalidChars: !CONTROL_CHAR_REGEX.test(trimmed) && !ZERO_WIDTH_REGEX.test(trimmed),
  };
};
